import React from 'react';
import { Table, Button, Label, Input } from "reactstrap";
import Loading from '../loading/Loading';
import './table-events-code.css'


class TableEventsCode extends React.Component {
    hardwareCode = {
        eventId: '',
        description: '',
        active: true,
        accountAwards: false
    }

    constructor(props) {
        super(props)


        this.state = {
            listHardwareCodes: [this.hardwareCode]
        }
    }
    columns = [
        'Código Evento', 'Descrição', 'Ativo?', 'Contabiliza na Premiação?', ''
    ]
    componentDidMount = () => {
        console.log('list', this.props.list)
        if (this.props.list) {
            // console.log('cai no set')
            this.setState({ listHardwareCodes: this.props.list })
        }
    }

    newEvent = () => {
        this.setState(prevState => ({
            listHardwareCodes: [...prevState.listHardwareCodes, this.hardwareCode]
        }))
    }

    change = (i, val, type) => {
        let listHardwareCodes = [...this.state.listHardwareCodes];
        if (type === 'cod') {
            listHardwareCodes[i] = { ...listHardwareCodes[i], eventId: parseInt(val) };
        } else if (type === 'desc') {
            listHardwareCodes[i] = { ...listHardwareCodes[i], description: val };
        } else if (type === 'active') {
            listHardwareCodes[i] = { ...listHardwareCodes[i], active: !listHardwareCodes[i].active };
        } else if (type === 'award') {
            listHardwareCodes[i] = { ...listHardwareCodes[i], accountAwards: !listHardwareCodes[i].accountAwards };
        }

        this.setState({ listHardwareCodes });
    }

    dropEvent = (i) => {
        let listHardwareCodes = [...this.state.listHardwareCodes];
        listHardwareCodes.splice(i, 1)

        this.setState({ listHardwareCodes });

    }

    render() {
        return (
            <div style={{ margin: '40px 0' }} className='container-table-events-code'>
                

                <div className="header-table-events">

                    <p style={{ fontSize: '15px', fontWeight: 'bold' }}>Tabela de Códigos de Evento</p>
                    <div className="container">

                        <div style={{ float: 'right', marginTop: '40px' }}>
                        <Button
                            // disabled={!bodyFilter.startPeriod || !bodyFilter.endPeriod || this.state.loading}
                            disabled={this.props.loading}
                            color="primary"
                            className="btn-filter btn-header-table-events telemetry-button"
                            onClick={() => this.newEvent()}>
                            Novo Evento
                        </Button>

                    
                        </div>


                    </div>

                </div>
                <div className='table-events-code'>
                    <Table responsive className="table-change-color">
                        <thead>
                            <tr>
                                {this.columns.map((d, i) => {
                                    return (
                                        <th key={i} style={{ minWidth: '200px' }}>{d}</th>
                                    )
                                })}
                            </tr>
                        </thead>

                        <tbody>
                            {this.state.listHardwareCodes.map((d, i) => {
                                return (
                                    <tr key={i} className='tr-table-pendencie tr-table-change-color'>
                                        <td>
                                            <input
                                                disabled={this.props.loading}
                                                type="number"
                                                className='form-control input-change-color'
                                                placeholder="Código do Evento"
                                                autoComplete="off"
                                                value={this.state.listHardwareCodes[i].eventId}
                                                onChange={(e) => this.change(i, e.target.value, 'cod')}
                                                style={{width: '240px'}}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                disabled={this.props.loading}
                                                type="text"
                                                className='form-control input-change-color'
                                                placeholder="Descrição do Evento"
                                                autoComplete="off"
                                                value={this.state.listHardwareCodes[i].description}
                                                onChange={(e) => this.change(i, e.target.value, 'desc')}
                                                style={{width: '240px'}}
                                            />
                                        </td>
                                        <td className="td-check-table-event">
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    onChange={() => this.change(i, null, 'active')}
                                                    checked={this.state.listHardwareCodes[i].active}
                                                    disabled={this.props.loading}
                                                    className="mg-input"
                                                />
                                                {this.state.listHardwareCodes[i].active ? 'Sim' : 'Não'}
                                            </Label>
                                        </td>
                                        <td className="td-check-table-event">
                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    onChange={() => this.change(i, null, 'award')}
                                                    checked={this.state.listHardwareCodes[i].accountAwards}
                                                    disabled={this.props.loading}
                                                    className="mg-input"
                                                />
                                                {this.state.listHardwareCodes[i].accountAwards ? 'Sim' : 'Não'}
                                            </Label>
                                        </td>

                                        <td>
                                            <Button
                                                // disabled={!bodyFilter.startPeriod || !bodyFilter.endPeriod || this.state.loading}
                                                disabled={this.props.loading}
                                                color="primary"
                                                className="btn-filter btn-drop-event-table-events telemetry-button"
                                                onClick={() => this.dropEvent(i)}>
                                                Apagar
                                            </Button>
                                        </td>

                                    </tr>
                                )
                            })}
                        </tbody>

                    </Table>
                    <div className="container">

                        <div style={{ float: 'right', marginTop: '40px' }}>

                            {this.props.loading ? (
                                <Loading size='small' />
                            ) : (
                                <div>
                                    {this.props.list ? (
                                        <Button
                                            // disabled={!bodyFilter.startPeriod || !bodyFilter.endPeriod || this.state.loading}
                                            color="primary"
                                            className="btn-filter btn-drop-event-table-events telemetry-button"
                                            onClick={() => this.props.redirect()}
                                            style={{ marginRight: '10px' }}>
                                            Voltar
                                        </Button>
                                    ) : null}

                                    <Button
                                        // disabled={!bodyFilter.startPeriod || !bodyFilter.endPeriod || this.state.loading}
                                        color="primary"
                                        className="btn-filter btn-drop-event-table-events telemetry-button"
                                        onClick={() => this.props.save(this.state.listHardwareCodes)}>
                                        {this.props.list ? 'Salvar' : 'Cadastrar'}
                                    </Button>
                                </div>
                            )}

                        </div>


                    </div>
                </div>
            </div>
        )
    }
}

export default TableEventsCode